import { QueryParams } from 'common/urls/QueryParams';
import { stringifyUrl } from 'query-string';
import { PromoCode, ViewMenu } from 'src/shared/design-system/ShefSocial/Icons';
import { Routes } from 'src/shared/Routes';
import { getIdSluggedPath } from 'src/shared/utils/RouteUtilities';
import { POST_TEXT } from '../../consts';
import { PostBodyProps } from '../../types';

export const useBody = (props: PostBodyProps) => {
  const {
    comment,
    id,
    isEditMode,
    isOnMenuPage = false,
    onChangeComment,
    mediaUrl,
    promoCode,
    promoText,
    promoCodeId,
    promoCodeString,
    shefId,
  } = props;

  return {
    buttonProps: {
      to: stringifyUrl({
        url: getIdSluggedPath(Routes.CONSUMER_ORDER_ONE_TIME, shefId),
        query: {
          ...(promoCodeString ? { [QueryParams.PROMO_CODE]: promoCodeString } : {}),
          [QueryParams.SHEF_POST_LOCATION]: 'feed',
          [QueryParams.SHEF_POST_SHEF_ID]: shefId,
          [QueryParams.SHEF_POST_ID]: id,
        },
      }),
      icon: promoCodeId ? PromoCode : ViewMenu,
      text: promoCodeId ? POST_TEXT.BODY.BUTTONS.REDEEM_CODE : POST_TEXT.BODY.BUTTONS.VISIT_MENU,
    },
    comment: comment ?? '',
    promoText,
    promoCode,
    isEditMode,
    inputProps: {
      onChange: onChangeComment,
      value: comment ?? '',
    },
    showButton: (!isOnMenuPage && (!!mediaUrl || !!promoCodeId)) || promoCodeId,
  };
};
